import type {
  RingIncomingCallCrmOps,
  RingIncomingCallRequest,
} from '@usecases/ring-incoming-call.usecase';

import type { IntegrationRepository } from '@infra/repositories/integration.repository';
import type { UserRepository } from '@infra/repositories/user.repository';

import { ScvObjectManager } from '@main/sf-connector/scv-object-manager';
import sleep from '@main/utils/sleep';

export class SalesforceRingIncomingCallCrmOps
  implements RingIncomingCallCrmOps
{
  constructor(
    private userRepository: UserRepository,
    private integrationRepository: IntegrationRepository,
  ) {}

  async postCall(call: RingIncomingCallRequest): Promise<void> {
    const { id: callUuid } = call;

    /**
     * TODO: Need to add better approach to handle concurrency.
     */
    await sleep(2000);

    await ScvObjectManager.updateVoiceObject(callUuid, callUuid);
  }
}
